import DOMPurify from 'dompurify';

/**
 * Sanitize plain text - removes all HTML tags and dangerous characters
 * Use this for text inputs that should never contain HTML
 * @param {string} text - Raw text input
 * @param {number} maxLength - Optional max length to enforce
 * @returns {string} - Sanitized plain text
 */
export const sanitizeText = (text, maxLength = null) => {
  if (!text || typeof text !== 'string') return '';
  
  // Use DOMPurify to strip all HTML
  let clean = DOMPurify.sanitize(text, { 
    ALLOWED_TAGS: [], // No HTML tags allowed
    ALLOWED_ATTR: [], // No attributes allowed
    KEEP_CONTENT: true // Keep the text content
  });
  
  // Additional cleanup for safety
  clean = clean
    .replace(/javascript:/gi, '') // Remove javascript: protocol
    .replace(/on\w+\s*=/gi, '') // Remove event handlers (onclick, onerror, etc)
    .trim();
  
  // Apply max length if specified
  if (maxLength && clean.length > maxLength) {
    clean = clean.slice(0, maxLength);
  }
  
  return clean;
};